import { useEffect } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

const ScrollToTop: React.FC<RouteComponentProps> = ({
  history,
}: RouteComponentProps) => {
  useEffect(() => {
    const listen = history.listen(() => {
      window.scrollTo(0, 0);
    });

    return () => {
      listen();
    };
  }, [history]);

  return null;
};

export default withRouter(ScrollToTop);
